import { createUseTranslationMap } from '@vend/react-utilities'
import { SaleStatus } from '../../models/sale.constants'

let saleDisplayStatusMap: Record<string, string> = {}

const buildSaleDisplayStatusMap = (t: any) => {
  saleDisplayStatusMap = {
    [SaleStatus.CLOSED]: t('Completed', { _context: 'Sale status' }),
    [SaleStatus.PARKED]: t('Parked', { _context: 'Sale status' }),
    [SaleStatus.VOIDED]: t('Voided', { _context: 'Sale status' }),
    [SaleStatus.ACCOUNT_SALE]: t('On Account', { _context: 'Sale status' }),
    [SaleStatus.ACCOUNT_SALE_CLOSED]: t('On Account, completed', {
      _context: 'Sale status',
    }),
    [SaleStatus.LAYBY_SALE]: t('Layby', { _context: 'Sale status' }),
    [SaleStatus.LAYBY_SALE_CLOSED]: t('Layby, completed', {
      _context: 'Sale status',
    }),
    [SaleStatus.RETURN_PARKED]: t('Parked Return', { _context: 'Sale status' }),
    [SaleStatus.RETURN_CLOSED]: t('Return, completed', {
      _context: 'Sale status',
    }),
    [SaleStatus.EXCHANGE_PARKED]: t('Parked Exchange', {
      _context: 'Sale status',
    }),
    [SaleStatus.EXCHANGE_CLOSED]: t('Exchange, completed', {
      _context: 'Sale status',
    }),
    [SaleStatus.QUOTE]: t('Quote', { _context: 'Sale status' }),
    [SaleStatus.AWAITING_PICKUP]: t('Pickup, unfulfilled', {
      _context: 'Sale status',
    }),
    [SaleStatus.AWAITING_DISPATCH]: t('Delivery, unfulfilled', {
      _context: 'Sale status',
    }),
    [SaleStatus.PICKED_UP_CLOSED]: t('Pickup, completed', {
      _context: 'Sale status',
    }),
    [SaleStatus.DISPATCHED_CLOSED]: t('Delivery, completed', {
      _context: 'Sale status',
    }),
  }
}

export const useSaleDisplayStatus = createUseTranslationMap(
  buildSaleDisplayStatusMap,
  (key: string) => saleDisplayStatusMap[key]
)
